import { SET_DRAFT_AVOID_SEGMENTS, CLEAR_DRAFT_AVOID_SEGMENTS } from 'actions';

const initialState = null;

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case SET_DRAFT_AVOID_SEGMENTS:
      return { profileIndex: payload.profileIndex, segmentIds: payload.segmentIds };
    case CLEAR_DRAFT_AVOID_SEGMENTS:
      return null;
    default:
      return state;
  }
};
